import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/products',
    name: 'products',
    meta: { title: 'Products', },
    component: () => import( '../views/products/index.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: { title: 'aboutUs', },
    component: () => import( '../views/aboutUs/index.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: 'contact', },
    component: () => import( '../views/contact/index.vue')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: { title: 'productDetail', },
    component: () => import( '../views/products/productDetail.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    meta: { title: 'blog', },
    component: () => import( '../views/blog/index.vue')
  },
  {
    path: '/blogDetails',
    name: 'blogDetails',
    meta: { title: 'blogDetails', },
    component: () => import('../views/blog/blogDetails.vue')
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    meta: { title: 'userCenter', },
    component: () => import( '../views/userCenter/index.vue')
  },
  {
    path: '/shopCart',
    name: 'shopCart',
    meta: { title: 'shopCart', },
    component: () => import( '../views/shopCart/index.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    meta: { title: 'checkOut', },
    component: () => import( '../views/checkOut/index.vue')
  },
  {
    path: '/shipping',
    name: 'shipping',
    meta: { title: 'shipping', },
    component: () => import( '../views/shipping/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { title: 'privacy', },
    component: () => import( '../views/bottomOther/privacy.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    meta: { title: 'privacy', },
    component: () => import( '../views/bottomOther/terms.vue')
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    meta: { title: 'privacy', },
    component: () => import( '../views/bottomOther/helpCenter.vue')
  },
  {
    path: '/hotKit',
    name: 'hotKit',
    meta: { title: 'privacy', },
    component: () => import( '../views/hotKit/index.vue')
  },
]



const router = new Router({
  // mode: 'history',
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})


let routeLoading = false

router.beforeEach((to, from, next) => {
  if (to.path !== from.path && from.matched.length > 0) {
    store.commit('showLoading')
    routeLoading = true
  }
  next()
})

router.afterEach(() => {
  if (routeLoading) {
    Vue.nextTick(() => {
      store.commit('hideLoading')
      routeLoading = false
    })
  }
})

// 保存原始的 push 方法
const originalPush = Router.prototype.push;

//重写 push 方法
Router.prototype.push = function push(location) {
  window.scrollTo({ top: 0, behavior: 'auto' });
  return originalPush.call(this, location).catch(err => {
    
  //   // 如果是重复导航错误，则忽略
  //   if (err.name !== 'NavigationDuplicated') {
  //     // 如果不是重复导航错误，则抛出错误
  //     // throw err;
  //   }
  });
};

export default router
